<div class="vc-appointments vc-view-shell">
  <main class="vc-appointments__layout vc-view-content">
    <section class="vc-appointments__frame vc-surface-panel">
      <app-calendar-appointments-wrapper
        class="vc-appointments__calendar"
        [date]="this.date"
      >
      </app-calendar-appointments-wrapper>
    </section>
  </main>
</div>
